import {
  CompanyIdentityProvider,
  UpdateCompanyIdentityProviderRequest,
  identityProvidersService,
} from '@aslanpay/portal-common-lib';
import { useMutation, useQueryClient } from '@tanstack/react-query';

interface UpdateIdentityProviderParams {
  companyId: string;
  id: string;
  request: UpdateCompanyIdentityProviderRequest;
}

const useUpdateIdentityProvider = () => {
  const queryClient = useQueryClient();

  return useMutation<CompanyIdentityProvider, Error, UpdateIdentityProviderParams>({
    mutationFn: async ({ companyId, id, request }: UpdateIdentityProviderParams) => {
      return identityProvidersService.updateIdentityProvider(companyId, id, request);
    },
    onSuccess: (_, { companyId }) => {
      queryClient.invalidateQueries({ queryKey: ['fetchIdentityProviders', companyId] });
    },
  });
};

export default useUpdateIdentityProvider;
